import { Box, Typography } from "@mui/material";
import * as React from "react";
// Use direct URL path like logo (PNG imports return objects in Parcel)
const favoritesScreenshot = "/favorites-screenshot.png";

export const FavoritesEmptyState: React.FC<{}> = () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
  >
    <Box
      sx={{
        mb: 2,
        border: "1px solid #ccc",
        borderRadius: 2,
        p: 1,
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <img
        src={favoritesScreenshot}
        alt="No favorites"
        style={{ height: 100 }}
      />
    </Box>
    <Typography textAlign="center" variant="body1" maxWidth={500}>
      No favorites currently saved. Click the “Save” icon to start saving your
      favorites stacks.
    </Typography>
  </Box>
);
